// const API_BASE_URL = 'http://127.0.0.1:8000/api'

// export default {
//   data () {
//     return {
//       API_BASE_URL: API_BASE_URL
//     }
//   }
// }

// export default {    // exportする
//   created() {
//       console.log('start! from mixins.')    // 起動後必ずログが出力される
//   },

//   data() {
//       return {
//           serverPass: "https://localhost:10443/",    // サーバーサイドのパスを定義
//       }
//   },

//   methods: {
//       logging() {
//           console.log('logging from mixins.')
//       }
//   },

//   computed: {
//       twoBytwo() {
//           return 2 * 2
//       }
//   }
// }

export default {
  data () {
    return {
      API_BASE_URL: 'https://70th-api.from.tv/api'
    }
  }
}



// WEBPACK FOOTER //
// ./src/variable.js